/* eslint-disable */
import React, { Component } from 'react';
import Text from '../Styled/Text';
import Headline from '../Styled/Headline';
import Closer from './Closer';

class FAQ extends Component {
  render() {
    return (
      <div>
        <Closer setInfoboxContent={this.props.setInfoboxContent} />
        <Headline>Was ist das jährliche Haushaltsbruttoeinkommen?</Headline>
        <Text>
          Das jährliche Haushaltsbruttoeinkommen umfasst die Einkommen aller
          Haushaltsmitglieder vor Abzug der Sozialversicherungsbeiträge und der
          direkten Steuern wie der Einkommensteuer. Zum Einkommen zählen Löhne,
          Einkommen aus selbstständiger Arbeit, unternehmerische Einkünfte,
          Zinsen, Dividenden, Mieteinnahmen, Renten und staatliche
          Transferleistungen wie beispielsweise Arbeitslosengeld und Kindergeld.
        </Text>

        <Headline>
          Wie errechnet sich die Einordnung in die Einkommensgruppen?
        </Headline>
        <Text>
          Dafür wird zunächst aus dem Bruttoeinkommen, der Anzahl der
          Erwachsenen und der Kinder im Haushalt das sogenannte
          bedarfsgewichtete Einkommen ermittelt (auch Äquivalenzeinkommen
          genannt). Damit werden die Einkommen verschiedener Haushaltstypen
          miteinander vergleichbar gemacht. Denn beispielsweise ein Paar mit
          vielen Kindern hat in der Regel einen geringeren Lebensstandard als
          ein Paar ohne Kinder mit dem gleichen Einkommen. Deshalb wird das
          gesamte jährliche Haushaltsbruttoeinkommen (siehe Frage oben) durch
          die bedarfsgewichtete Zahl der Haushaltsmitglieder geteilt. Der erste
          Erwachsene hat den Faktor 1, jedes weitere Haushaltsmitglied über 14
          Jahren den Faktor 0,5, Kinder unter 14 Jahren den Faktor 0,3. Damit
          wird berücksichtigt, dass Kinder weniger Geld brauchen als Erwachsene,
          und dass das Leben in einigen Bereichen günstiger wird, wenn mehrere
          Menschen zusammenleben. In einem zweiten Schritt werden alle Haushalte
          in Deutschland nach der Höhe dieses Einkommens von Arm nach Reich
          aufgereiht und in 100 gleich große Gruppen unterteilt. Das 1. Prozent
          ist die ärmste EInkommensgruppe, das 100. Prozent die reichste.. Mit
          diesem Verfahren muss ein Paar ohne Kinder nur über etwa 70 Prozent
          des Einkommens eines Paares mit 2 kleinen Kindern verfügen, um
          statistisch zur selben Einkommensgruppe zu gehören.
        </Text>

        <Headline>Was zeigen die Linien in der Grafik?</Headline>
        <Text>
          Die Linien zeigen den Verlauf der durchschnittlichen
          Einkommensteuerzahlungen inklusive Solidaritätszuschlag in Euro pro
          Jahr je Erwachsenem in den verschiedenen Einkommensgruppen der
          Bevölkerung in Deutschland, angefangen vom ärmsten Prozent links bis
          zum reichsten Prozent rechts. Jede Linie steht für den Verlauf in
          einem der Jahre 1998, 2004, 2007, 2010, 2014 und 2019. Im
          Ausgangszustand ist das aktuellste verfügbare Jahr 2019 hervorgehoben.
          Der angezeigte Wert am Schnittpunkt mit der vertikalen Linie zeigt die
          entsprechende Steuerzahlung in der ausgewählten Einkommensgruppe.
          Mittels der Eingabefelder oberhalb der Grafik lässt sich sowohl das
          markierte Prozent in der Einkommensverteilung als auch das betrachtete
          Jahr mit der entsprechenden Kurve für den Verlauf der Steuerzahlungen
          verändern. Die Kurven wurden mit einem statistischen Verfahren
          geglättet, da die Steuerlast je erwachsener Person von
          Einkommensgruppe zu Einkommensgruppe schwanken kann. Denn in einem
          Einkommensprozent befinden sich verschiedene Haushaltstypen wie
          Familien und Alleinlebende mit einem ähnlichen Äquivalenzeinkommen
          (siehe Fragen 1 und 2). Trotz ihres vergleichbarem Lebensstandard kann
          sich das Einkommen und die darauf fällige Einkommensteuer deutlich
          unterscheiden.
        </Text>

        <Headline>Warum steigt die Kurve steil an?</Headline>
        <Text>
          Die Grafik zeigt im Ausgangszustand den durchschnittlichen
          Einkommensteuersatz eines Erwachsenen in der jeweiligen
          Einkommensgruppe. Oberhalb der Grafik lässt sich die Ansicht von
          “Einkommensteuer in Prozent des Einkommens” auf “Einkommensteuer in
          Euro pro Jahr” umschalten. In beiden Ansichten steigt die Kurve von
          niedrigen zu hohen Einkommen stetig an, in der Ansicht mit
          Euro-Beträgen deutlich steiler als in der Ansicht mit prozentualen
          Anteilen. Das liegt zum einen daran, dass mit steigendem Einkommen
          auch der Anteil der zu zahlenden Einkommensteuer steigt (progressiver
          Tarif). Zum anderen zahlen wohlhabendere Steuerzahler diesen höheren
          Steuersatz auf ein höheres Einkommen. Bezieher niedrigerer Einkommen
          zahlen einen geringeren Anteil eines geringeren Einkommens. Beide
          Faktoren zusammen führen zu einem überproportionalen Anstieg der zu
          zahlenden Summe von niedrigen zu hohen Einkommensgruppen. Der
          Vergleich im Zeitverlauf zeigt, dass die Belastung in allen
          Einkommensgruppen gestiegen ist, aber insbesondere die hohen Einkommen
          stärker belastet wurden.
        </Text>

        <Headline>Auf welchen Daten basiert die Auswertung?</Headline>
        <Text>
          Die Berechnungen basieren auf Daten zur Einkommensverteilung des
          Sozio-oekonomischen Panels (SOEP) und der Lohn- und
          Einkommensteuerstatistik (FAST). Das SOEP ist eine seit 1984
          durchgeführte repräsentative Wiederholungsbefragung in Deutschland von
          aktuell über 40.000 Personen aus mehr als 18.000 Haushalten. Aktuell
          sind die SOEP-Daten bis zum Jahr 2018 verfügbar (im Rahmen der Analyse
          fortgeschrieben auf das Jahr 2019) und bilden die Einkommensverteilung
          größtenteils repräsentativ ab. Für die sehr hohen Einkommen, die in
          Umfragedaten wie dem SOEP in der Regel nicht enthalten sind, werden
          die Steuerdaten der FAST hinzugezogen. Die FAST-Daten sind
          anonymisierte 10-Prozent-Stichproben aller Lohn- und
          Einkommensteuerfälle eines Steuerjahres, die in unregelmäßigen
          Abständen erscheinen. Die zuletzt verfügbaren Daten stammen aus dem
          Jahr 2014 und wurden auf das Jahr 2019 fortgeschrieben.
        </Text>
      </div>
    );
  }
}

export default FAQ;
